module.exports = __webpack_public_path__ + "media/images/front/search-glass-859236b5b4b6f1c93005359a6040e7d3.svg";